import axios from 'axios';
import { loginService } from './LoginService';

export const providersService = {
  getProviders,
  addProvider,
  editProvider,
  getWhatsAppProviders,
  addProductAttributions,
  getSpecificSupplier,
  deleteAttribution,
  getProductAttributions
}

function getProviders(pageNumber) {
  let url = `${process.env.REACT_APP_API_URL}/api/suppliers?page[number]=${pageNumber ? pageNumber : 1}`;

  const requestOptions = {
    method: 'GET',
    url,
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/json'
    }
  }
  if (loginService.loggedIn()) {
    requestOptions.headers['Authorization'] = loginService.getToken();
  }

  return axios(requestOptions);
}

function getWhatsAppProviders() {
  let url = `${process.env.REACT_APP_API_URL}/api/suppliers/whatsapp_eligible`;

  const requestOptions = {
    method: 'GET',
    url,
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/json'
    }
  }
  if (loginService.loggedIn()) {
    requestOptions.headers['Authorization'] = loginService.getToken();
  }

  return axios(requestOptions);
}


function addProvider(providerData) {
  console.log(providerData)
  let url = `${process.env.REACT_APP_API_URL}/api/suppliers`;
  const requestOptions = {
    method: 'POST',
    url,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    data: {
      supplier: {
        name: providerData.name,
        email: providerData.email,
        phone: providerData.phone,
        entity_type: providerData.entity_type,
        registration_number: providerData.registration_number,
        cui: providerData.cui,
        vat_payer: providerData.vat_payer,
        bank_name: providerData.bank_name,
        iban: providerData.iban,
        representative_name: providerData.representative_name,
        country: providerData.country,
        county: providerData.county,
        city: providerData.city,
        street: providerData.street,
        street_number: providerData.street_number,
        postal_code: providerData.postal_code,
        service_type: providerData.service_type,
        participates_in_offering: providerData.participates_in_offering,
        order_day: providerData.order_day
      }
    }
  };

  if (loginService.loggedIn()) {
    requestOptions.headers['Authorization'] = loginService.getToken();
  }

  return axios(requestOptions);
}
function editProvider(providerId, providerData) {
  const url = `${process.env.REACT_APP_API_URL}/api/suppliers/${providerId}`;

  const requestOptions = {
    method: 'PATCH',
    url,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    data: {
      supplier: {
        name: providerData.name,
        email: providerData.email,
        phone: providerData.phone,
        entity_type: providerData.entity_type,
        registration_number: providerData.registration_number,
        cui: providerData.cui,
        vat_payer: providerData.vat_payer,
        bank_name: providerData.bank_name,
        iban: providerData.iban,
        representative_name: providerData.representative_name,
        country: providerData.country,
        county: providerData.county,
        city: providerData.city,
        street: providerData.street,
        street_number: providerData.street_number,
        postal_code: providerData.postal_code,
        service_type: providerData.service_type,
        participates_in_offering: providerData.participates_in_offering !== undefined ? Boolean(providerData.participates_in_offering) : false,
        order_day: providerData.order_day
      }
    }
  };

  if (loginService.loggedIn()) {
    requestOptions.headers['Authorization'] = loginService.getToken();
  }

  return axios(requestOptions);
}
function addProductAttributions(supplierId, products) {
  let url = `${process.env.REACT_APP_API_URL}/api/suppliers/${supplierId}/add_product_attribution`;
  const requestOptions = {
    method: 'POST',
    url,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    data: {
      product_ids: products,
      priority:0,
      status:"active"
    }
  };

  if (loginService.loggedIn()) {
    requestOptions.headers['Authorization'] = loginService.getToken();
  }

  return axios(requestOptions);
}
function getSpecificSupplier(supplierId) {
  let url = `${process.env.REACT_APP_API_URL}/api/suppliers/${supplierId}`;

  const requestOptions = {
    method: 'GET',
    url,
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/json'
    }
  }
  if (loginService.loggedIn()) {
    requestOptions.headers['Authorization'] = loginService.getToken();
  }

  return axios(requestOptions);
}
function deleteAttribution(providerId, productId) {
  const url = `${process.env.REACT_APP_API_URL}/api/suppliers/${providerId}/remove_product_attribution/${productId}`;

  const requestOptions = {
    method: 'DELETE',
    url,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  };

  if (loginService.loggedIn()) {
    requestOptions.headers['Authorization'] = loginService.getToken();
  }

  return axios(requestOptions);
}
function getProductAttributions(supplierId) {
  let url = `${process.env.REACT_APP_API_URL}/api/suppliers/${supplierId}/product_attributions`;

  const requestOptions = {
    method: 'GET',
    url,
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/json'
    }
  }
  if (loginService.loggedIn()) {
    requestOptions.headers['Authorization'] = loginService.getToken();
  }

  return axios(requestOptions);
}
